import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, createSuper as _createSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { PureComponent, createRef, Component } from 'react';
import { IE11Filmstrip, NicolletFilmstripDiv } from './styles.js';
import { FilmstripNavButton as FilmstripNavButton$1 } from './FilmstripNavButton/FilmstripNavButton.js';
import { FilmstripPaginationDots as FilmstripPaginationDots$1 } from './FilmstripPaginationDots/FilmstripPaginationDots.js';
import { FilmstripNavigationCause } from './PageChange.js';
import { FilmstripController as FilmstripController$1 } from './FilmstripController.js';
import isMicrosoftBrowser from '../../utilities/isMicrosoftBrowser/index.js';

var Filmstrip = /*#__PURE__*/function (_PureComponent) {
  _inherits(Filmstrip, _PureComponent);

  var _super = _createSuper(Filmstrip);

  function Filmstrip() {
    _classCallCheck(this, Filmstrip);

    return _super.apply(this, arguments);
  }

  _createClass(Filmstrip, [{
    key: "render",
    value: function render() {
      if (isMicrosoftBrowser()) {
        var children = React__default.Children.toArray(this.props.children) || [];
        return children.length ? React__default.createElement(IE11Filmstrip, null, React__default.createElement("div", {
          className: "children"
        }, children)) : null;
      }

      return React__default.createElement(FilmstripModern, Object.assign({}, this.props));
    }
  }]);

  return Filmstrip;
}(PureComponent);
/**
   Filmstrip component!

   Lazy rendering approach:
   1. Obtain a best guess at how many items will be on the first page. Allow that many children to render.
   2. Once the filmstrip is calibrated, it will call our callback, and present us with accurate measurements.
   3. Based on those, we can adjust the number of rendered children to cover the present page and the next one.
 */


var FilmstripModern = /*#__PURE__*/function (_Component) {
  _inherits(FilmstripModern, _Component);

  var _super2 = _createSuper(FilmstripModern);

  function FilmstripModern(props) {
    var _this;

    _classCallCheck(this, FilmstripModern);

    var _a;

    _this = _super2.call(this, props);

    _this.onCalibrate = function (controller) {
      _this.updateRenderedChildren(controller);
    };

    _this.onPageWillChange = function (pageChange) {
      // Call any external callback
      if (_this.props.onPageWillChange) _this.props.onPageWillChange(pageChange);
    };

    _this.onPageChanged = function (pageChange) {
      // After the animation finishes, render the next page of items
      _this.updateRenderedChildren(_this.controller); // Call any external callback


      if (_this.props.onPageChanged) _this.props.onPageChanged(pageChange); // if page change was caused by the API, make sure visibility is reset

      if (pageChange.cause === FilmstripNavigationCause.api) _this.controller.show();

      _this.setState({
        currentPage: pageChange.newPage
      });
    };

    _this.goToInitialPosition = function () {
      var _a;

      var page = _this.props.goToPage;
      if (_this.props.goToItem) page = _this.controller.pages.getPageByItemIndex((_a = _this.props.goToItem) !== null && _a !== void 0 ? _a : 0); // Hide the component while we scroll to the correct page

      if (page) {
        _this.controller.pages.setPage(page, FilmstripNavigationCause.api);
      } else {
        _this.controller.show();
      }
    };

    _this.goToPage = function () {
      var _a;

      _this.controller.pages.setPage((_a = _this.props.goToPage) !== null && _a !== void 0 ? _a : 0, FilmstripNavigationCause.api);
    };

    _this.goToItem = function () {
      var _a;

      var page = _this.controller.pages.getPageByItemIndex((_a = _this.props.goToItem) !== null && _a !== void 0 ? _a : 0);

      if (page !== undefined) _this.controller.pages.setPage(page, FilmstripNavigationCause.api);
    };
    /** a ref to the main element */


    _this.ref = createRef();
    _this.state = {
      /** The number of passed children to actually render. If hasVariableItemWidths is true, lazy rendering is disabled, so renderedChildren will always be the same as the child count. */
      renderedChildren: props.hasVariableItemWidths ? _this.reactChildCount : Math.max(2, (_a = _this.props.itemsPerPageHint) !== null && _a !== void 0 ? _a : 6),

      /** This is only used to pass the page number to FilmstripPaginationDots */
      currentPage: 0
    };
    return _this;
  } // Lifecycle methods

  /* maps to web components' connectedCallback() */


  _createClass(FilmstripModern, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          goToPage = _this$props.goToPage,
          goToItem = _this$props.goToItem,
          _this$props$hasVariab = _this$props.hasVariableItemWidths,
          hasVariableItemWidths = _this$props$hasVariab === void 0 ? false : _this$props$hasVariab;
      var onCalibrate = this.onCalibrate,
          onPageChanged = this.onPageChanged,
          onPageWillChange = this.onPageWillChange;
      this.controller = new FilmstripController$1(this.ref.current, {
        onCalibrate: onCalibrate,
        onPageChanged: onPageChanged,
        onPageWillChange: onPageWillChange,
        hasVariableItemWidths: hasVariableItemWidths
      });
      this.controller.totalItems = this.reactChildCount;

      if (goToPage || goToItem) {
        // Hide the component while we scroll to the correct page
        this.controller.hide(); // wait for controller to finish calibrating, then go there

        setTimeout(this.goToInitialPosition, 0);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.children !== this.props.children || nextState.renderedChildren !== this.state.renderedChildren || nextState.currentPage !== this.state.currentPage;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          children = _this$props2.children,
          goToPage = _this$props2.goToPage,
          goToItem = _this$props2.goToItem,
          hideNavButtons = _this$props2.hideNavButtons;
      var _this$controller = this.controller,
          show = _this$controller.show,
          pages = _this$controller.pages,
          removeNavButtonEvents = _this$controller.removeNavButtonEvents,
          attachNavButtonEvents = _this$controller.attachNavButtonEvents,
          updateNavVisibility = _this$controller.updateNavVisibility; // if goTo* is present but there is only one page at a particular viewport size we need to remove the .hide class

      if (pages.length === 1) show();
      if (children !== prevProps.children) this.controller.totalItems = this.reactChildCount;
      if (goToPage !== prevProps.goToPage) this.goToPage();
      if (goToItem !== prevProps.goToItem) this.goToItem();

      if (hideNavButtons !== prevProps.hideNavButtons) {
        if (hideNavButtons) removeNavButtonEvents();else attachNavButtonEvents();
        updateNavVisibility();
      }
    }
    /* maps to web components' disconnectedCallback() */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.controller) {
        this.controller.destroy();
        this.controller = undefined;
      }
    }
  }, {
    key: "updateRenderedChildren",

    /** Take the filmstrip controller as an argument because this gets called from inside the controller's constructor, at which point this.controller won't be quite ready yet, since it will not have been returned by that constructor. :) */
    value: function updateRenderedChildren(controller) {
      var _controller$pages = controller.pages,
          nextPage = _controller$pages.nextPage,
          currentPage = _controller$pages.currentPage,
          filmstripIsEmpty = controller.items.filmstripIsEmpty;

      if (!filmstripIsEmpty && !this.props.hasVariableItemWidths) {
        // The +2 below is because:
        // +1 to account for any potential partially offscreen items, and
        // +1 to get from an index to a count
        var newRenderedChildren = nextPage ? nextPage.lastItemIndex + 2 : currentPage.lastItemIndex + 2;

        if (newRenderedChildren !== this.state.renderedChildren && this.controller) {
          this.setState({
            renderedChildren: newRenderedChildren
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _a, _b, _c, _d;

      var _this$props3 = this.props,
          style = _this$props3.style,
          className = _this$props3.className,
          dataTest = _this$props3.dataTest,
          hideNavButtons = _this$props3.hideNavButtons,
          previousButtonAriaLabel = _this$props3.previousButtonAriaLabel,
          nextButtonAriaLabel = _this$props3.nextButtonAriaLabel;
      var children = React__default.Children.toArray(this.props.children) || [];
      return React__default.createElement(React__default.Fragment, null, React__default.createElement(NicolletFilmstripDiv, {
        className: className,
        "data-test": dataTest,
        ref: this.ref,
        style: style
      }, !hideNavButtons && React__default.createElement(FilmstripNavButton$1, {
        ariaLabel: previousButtonAriaLabel,
        direction: "back",
        hiddenInitially: true
      }), React__default.createElement("div", {
        className: "children",
        tabIndex: -1
      }, children.slice(0, this.state.renderedChildren)), !hideNavButtons && React__default.createElement(FilmstripNavButton$1, {
        ariaLabel: nextButtonAriaLabel,
        direction: "forward"
      })), this.props.hasPaginationDots && React__default.createElement(FilmstripPaginationDots$1, {
        currentPageIndex: (_b = (_a = this.controller) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b.currentPageIndex,
        totalPages: (_d = (_c = this.controller) === null || _c === void 0 ? void 0 : _c.pages) === null || _d === void 0 ? void 0 : _d.length
      }));
    }
  }, {
    key: "reactChildCount",
    get: function get() {
      return React__default.Children.count(this.props.children);
    }
  }]);

  return FilmstripModern;
}(Component);

FilmstripModern.defaultProps = {
  hasVariableItemWidths: false
};

export default Filmstrip;
export { Filmstrip, FilmstripModern };
